import StepWizard from "react-step-wizard"
import { SelectFirstDate, SelectSecondDate, SelectThirdDate, Response } from "./Stepper"
import './SelectDates.css'
import { Resume } from "./Stepper/Resume"
import clsx from "clsx"
import useMediaQuery from "../../../hook/useMediaQuery"
import { MediaMobile } from "../../../api/const/MediaQuery"
import { AppGeneralContext } from "shared/GeneralContext/GeneralContext"
import { useContext, useEffect, useState } from "react"
import { Loader } from "components/atoms"

export const SelectDates = () => {
    const mobile = useMediaQuery(MediaMobile)
    const { startUpById, baseUri, IsLoadingGetStartupbyId } = useContext(AppGeneralContext)
    const [name, setName] = useState<string>("")
    const [logo, setLogo] = useState<string>("")
    const [isLoading, setIsLoading] = useState<boolean>(true)

    let custom = {
        enterRight: '',
        enterLeft: '',
        exitRight: '',
        exitLeft: '',
        intro: ''
    }

    useEffect(() => {
        if (IsLoadingGetStartupbyId) {
            setIsLoading(true)
            return
        }
        const timerId = setTimeout(() => {
            setIsLoading(false)
        }, 1000);

        return () => {
            clearTimeout(timerId)
        }
    }, [IsLoadingGetStartupbyId])


    useEffect(() => {
        setName(startUpById.name ?? "")
        setLogo(startUpById.logoUrl ? `${baseUri}${startUpById.logoUrl}` : "/logo192.png")
    }, [startUpById])

    return (
        isLoading ?
            <div style={{ height: "60vh" }} className="d-flex  justify-content-center align-items-center"> <Loader /> </div>
            :

            <div className={clsx(" w-100 h-100", { " ": mobile })}>
                <div className={clsx("w-80 d-flex  align-items-start",
                    { " pt-2 pe-3": mobile })}>
                    <img src={logo} alt={`${name} logo`} className="logo-startup" />
                    <h3 className="m-0 p-0 ps-3 fw-bold  me-5 ">Book a Video Call with {name}</h3>
                </div>
                <p className="m-0 p-0 pt-3">
                    <h5>
                        Select three available dates
                    </h5>
                </p>

                <div className={clsx("",)}>
                    <StepWizard transitions={custom} className='w-100 h-100 datesModal'   >
                        <SelectFirstDate />
                        <SelectSecondDate />
                        <SelectThirdDate />
                        <Resume name="resume" />
                        <Response />
                    </StepWizard>
                </div>
            </div>

    )
}